module.exports = __webpack_public_path__ + "static/media/Coves-of-Northville-Rules-and-Regulations.673231fd.pdf";